/* Franchising Maps */
///////////////////////////////
///////////////////////////////
if (!customElements.get('franchising-maps')) {

    class FranchisingMaps extends HTMLElement {
        constructor() {
            super();
    
            this.states = this.querySelectorAll(".franchising-maps__map svg > path, .franchising-maps__map svg > g ");
            this.detailItems = this.querySelectorAll(".franchising-maps__details__item"); 
            this.activeState = this.querySelector(".franchising-maps__details__item.__active")?.dataset?.state;

            if (!this.states || !this.activeState) return;

            this.init(); 
        }
    
        init() {

            this.states.forEach((state) => {
                if (state.classList[0] == this.activeState) {
                    state.classList.add("__active");
                }
            })

            this.states.forEach((state, i) => {
                state.addEventListener('mouseenter', (e) => {
                    this.states.forEach((item) => {
                        item.classList.remove("__active");
                    })
                    e.target.classList.add("__active");
                    let state = e.target.classList[0];

                    this.detailItems.forEach((item) => {
                        if (item.dataset?.state == state){
                            item.classList.add("__active");
                        } else {
                            item.classList.remove("__active");
                        }
                    })
                });
            })
        }
    }

    customElements.define('franchising-maps',  FranchisingMaps);
}